import { ref } from 'vue'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { notifications } from '@/util'
import fetchData from '@/util/fetch'

// the form -> preview (dry run) -> result flow shared by the batch modals; both
// batch endpoints return the same { dry_run, summary, data: [{ result }] } envelope
export default function useBatchSubmit({ url, buildBody, invalidateKeys, createdMessage }) {
  const queryClient = useQueryClient()

  const step = ref('form')
  const batchResult = ref(null)

  const { mutate: submitBatch, isLoading: batchLoading } = useMutation({
    mutationFn: (dryRun) =>
      fetchData(url, {
        method: 'POST',
        body: JSON.stringify({ ...buildBody(), dry_run: dryRun }),
      }),
    onError: (e) => {
      console.error(`Error on batch request to ${url}`, e)
      const info = e.message || e.detail || e
      notifications.addNotification({
        message: `Error occured, ${info}`,
        type: 'danger',
      })
    },
    onSuccess: (data) => {
      batchResult.value = data
      if (data.dry_run) {
        step.value = 'preview'
        return
      }

      step.value = 'result'
      invalidateKeys.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }))
      notifications.addNotification({
        message: createdMessage(data.summary.created || 0),
        type: 'success',
      })
    },
  })

  const runDryRun = () => submitBatch(true)
  const runCreate = () => submitBatch(false)

  return { step, batchResult, batchLoading, runDryRun, runCreate }
}
